<template>
  <div class="animated fadeIn">

    <b-row>
      <b-col lg="12">
      <!--  <b-breadcrumb :items="breadcrumbs"/>   -->  
       <b-card header-tag="header" footer-tag="footer">
        <div slot="header">
          <i class="fa fa-align-justify"></i><strong> COD Status Report</strong>  
        </div>
        <b-row class="mb-4">          
          <b-col md="6" class="my-1">
            <b-col sm="12" >
            <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
              <b-input-group>
                <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          </b-col>
          <b-col md="6" class="my-1">
           <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
            <b-row class="form-group">
              <b-col cols="2" >
                <label>Date:</label>
              </b-col>
              <b-col cols="6">
                 <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectedDate'>
                </v-date-picker> 
              </b-col>
              <b-col cols="4">
                <b-button size="md" variant="primary" type="submit" @click="displaydata">Submit</b-button>
              </b-col>
            </b-row>               
            </form>               
          </b-col>           
        </b-row>
        <b-col sm="12" class="text-right">
               <p > <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p>
              </b-col> 
            <b-col sm="12" >
        <b-table show-empty stacked="md"  :items="items"  :fields="fields"  :current-page="currentPage"    :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered"  :busy="isBusy"  :bordered="bordered" > 
          <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
        </b-table> 
            </b-col>
       <!--  <b-col md="6" class="my-1" v-if="this.totalRows > 10">
          <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
        </b-col> -->

       </b-card>
        
      </b-col>
    </b-row><!--/.row-->

  </div>

</template>

<script>
import CONSTANTS from '@/utils/constants'
import Filters from '@/utils/filters'
import Utils from '@/utils'
export default {
  data: function() {
    return {
      name: 'codReports',
      data: [],
      items:[],
      isBusy: false,
      breadcrumbs: [{
        text: 'Dashboard',
        href: '/dashboard'
      },{
        text: 'COD Status Report',
        active: true
      }],
      fields: [
          { key: 'daname', label: 'Delivery Agent', sortable: true, sortDirection: 'desc' },
          { key: 'codcollectable', label: 'COD Collected', sortable: true},
          
      ],
      bordered: true,
      totalRows: 0,
      currentPage: 1,
     // perPage:  10,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      selectedDate: new Date(),
    }
  },
  computed: {
    sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
  },
  created: function () {
    this.displaydata()
  },

  methods: {
      info(item, index, button) {
        this.infoModal.title = `Row index: ${index}`
        this.infoModal.content = JSON.stringify(item, null, 2)
        this.$root.$emit('bv::show::modal', this.infoModal.id, button)
      },
      resetInfoModal() {
        this.infoModal.title = ''
        this.infoModal.content = ''
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
    validateForm(scope) {},
    // refresh: function () {
    //   document.getElementById('refreshId').className = 'fa-spin fa fa-refresh'
    //   this.displaydata()
    // },
    displaydata: function () {
       this.isBusy = true;
      var fromdate = this.formatDate(this.selectedDate);

      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      const customerGetobj = {
          deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
            fromdate: `${fromdate}`,
            hub_id:`${userInfo.pickuplocationmasterid}`,
            is_finance_superadmin:`${userInfo.is_finance_superadmin}`,
      }
      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getalldacodstatusreport`, customerGetobj)
        .then((result) => {
          if (result.body.returnmsg === 'Successful') {
            this.isBusy = !this.isBusy
            this.data = result.body.returnvalue
            this.items  = result.body.returnvalue;
            this.totalRows = result.body.returnvalue.length
            //document.getElementById('refreshId').className = 'fa fa-refresh'
          } else {
            this.isBusy = !this.isBusy
            this.items  = result.body.returnvalue;
            this.totalRows = result.body.returnvalue.length
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    },
    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },
  }
}
</script>

